var exports = {
  "O8": "overlay-fade-in__O6Jcd6",
  "ez": "content-scale-fade-in__xxJRIW",
  "Lw": "overlay__lEgjAI",
  "oe": "centeredContent__hpw_7D",
  "Qq": "text__mAUiAM",
};

module.exports = exports;
